/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetContractTemplateRequest = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
